import React, { useState } from "react";
import "./AADevine.css";
import fetchBase from "../utils/fetchBase";

const AADevine = () => {
    const [form, setForm] = useState({
            name: "",
            lovedOneName: "",
            phone: "",
            zip: "",
            veteran: "",
    });
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const [error, setError] = useState(false);

        const handleSubmit = async (e) => {
            e.preventDefault();
            setError(false);

            try {
                const res = await fetch(`${fetchBase}/api/leads/aa-devine`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(form),
                });

                if (!res.ok) {
                    throw new Error("Submission failed");
                }

                setSubmitted(true);
            } catch (err) {
                setError(true);
            }
        };

    return (
        <div className="devine-page">
            {/* Top Bar */}
            <div className="devine-topbar">
                <img
                    src="/images/AADevine.png"
                    alt="A&A Devine Home Health"
                    className="devine-topbar-logo"
                />
                <a href="tel:4696057230" className="devine-topbar-call">
                    Call Direct: (469) 605-7230 — Available 24/7
                </a>
            </div>

            {/* Hero */}
            <section className="devine-hero">
                <div className="devine-hero-copy">
                    <img
                        src="/images/MomGma.png"
                        alt="Caregiver serving a meal tray to an elderly client at home"
                        className="devine-hero-image"
                    />
                    <h1>Compassionate, Reliable In-Home Senior Care in Melissa, Allen, Plano &amp; McKinney</h1>
                    <p className="devine-subhead">
                        Stop carrying caregiver burnout alone. We match your parent with
                        background-checked caregivers for daily meals, mobility, and
                        companionship — so you can go back to being their son or daughter.
                    </p>
                    <ul className="devine-trust-badges">
                        <li>✓ Fully Licensed &amp; Insured</li>
                        <li>✓ 100% Background-Checked Staff</li>
                        <li>✓ VA Benefit Authorized</li>
                    </ul>
                </div>

                <div className="devine-form-card">
                    {submitted ? (
                        <div className="devine-form-success">
                            <h3>Thank you.</h3>
                            <p>
                                A care coordinator will reach out shortly. If this is urgent,
                                call us directly at{" "}
                                <a href="tel:4696057230">(469) 605-7230</a>.
                            </p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="devine-form">
                            <h3>Schedule a Free, No-Obligation In-Home Care Consultation</h3>

                            <label>
                                Requester's Name
                                <input
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    required
                                />
                            </label>

                            <label>
                                Loved One's Full Name
                                <input
                                    type="text"
                                    name="lovedOneName"
                                    value={form.lovedOneName}
                                    onChange={handleChange}
                                    required
                                />
                            </label>

                            <label>
                                Phone Number
                                <input
                                    type="tel"
                                    name="phone"
                                    value={form.phone}
                                    onChange={handleChange}
                                    required
                                />
                            </label>

                            <label>
                                Parent's Zip Code
                                <input
                                    type="text"
                                    name="zip"
                                    value={form.zip}
                                    onChange={handleChange}
                                    required
                                />
                            </label>

                            <label>
                                Are they a wartime veteran or spouse?
                                <select
                                    name="veteran"
                                    value={form.veteran}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="" disabled>
                                        Select one
                                    </option>
                                    <option value="yes">Yes</option>
                                    <option value="no">No</option>
                                    <option value="not_sure">Not Sure</option>
                                </select>
                            </label>

                            {error && (
                                <p style={{ color: "#B91C1C", fontSize: "14px", marginBottom: "16px" }}>
                                    Something went wrong. Please try again, or call us directly at (469) 605-7230.
                                </p>
                            )}

                            <button type="submit" className="devine-cta">
                                GET MY FREE CARE ASSESSMENT
                            </button>
                        </form>
                    )}
                </div>
            </section>

            {/* Empathy Section */}
            <section className="devine-empathy">
                <h2>You Don't Have to Do This All Yourself</h2>
                <p>
                    Balancing your own career, children, and marriage while managing an
                    aging parent's health is overwhelming. Whether Mom needs help getting
                    dressed safely in the morning, or Dad needs companionship and meal
                    prep so he doesn't wander, our team steps in to handle the daily
                    physical work — giving you back peace of mind.
                </p>

                <div className="devine-checklist">
                    <div>
                        <h4>Skilled &amp; Non-Skilled Care</h4>
                        <ul>
                            <li>Bathing, Dressing &amp; Grooming</li>
                            <li>Skilled Nursing &amp; Wound Care</li>
                            <li>Medication Reminders &amp; Administration</li>
                            <li>Mobility Assistance &amp; Fall Prevention</li>
                            <li>Feeding, Toileting &amp; Positioning</li>
                            <li>Light Housekeeping &amp; Transportation</li>
                        </ul>
                    </div>
                    <div>
                        <h4>Pediatric Care</h4>
                        <ul>
                            <li>Private Duty Skilled Nursing</li>
                            <li>Medical Nutrition Therapy</li>
                            <li>Speech-Language Therapy</li>
                            <li>Occupational &amp; Physical Therapy</li>
                            <li>G-Button Care</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* VA & Funding */}
            <section className="devine-funding">
                <h2>Confused About How to Pay for Care?</h2>
                <p>
                    Quality care doesn't always have to come out of pocket. We help local
                    families navigate private-pay budgets, Long-Term Care Insurance, and{" "}
                    <strong>VA Aid &amp; Attendance benefits</strong>. If your parent or
                    their spouse served during wartime, they may qualify for hours of care
                    at little to no cost. We guide you through the process for free —
                    proudly serving the DFW veteran community.
                </p>
            </section>

            {/* Trust / Reviews */}
            <section className="devine-trust">
                <h2>What Other Local Families Say</h2>
                <div className="devine-review-cards">
                    <div className="devine-review-card">
                        <p>
                            "I was overwhelmed trying to care for my mother after her fall.
                            A&amp;A Devine had a caregiver at her house within days. She
                            feels like family to us now."
                        </p>
                        <span>— Adult Daughter, Melissa TX</span>
                    </div>
                    <div className="devine-review-card">
                        <p>
                            "They helped us understand my father's VA benefits when we
                            thought we'd have to cover everything ourselves. I can't
                            recommend them enough."
                        </p>
                        <span>— Adult Son, Plano TX</span>
                    </div>
                </div>
                <p className="devine-owner-note">
                    Family owned and led by <strong>Esther Tabenyang, RN</strong>, with 15
                    years of nursing experience.
                </p>
            </section>

            {/* Process */}
            <section className="devine-process">
                <h2>What Happens Next</h2>
                <ol>
                    <li>
                        <span className="devine-step-num">1</span>
                        <div>
                            <h4>Quick 10-Minute Phone Call</h4>
                            <p>
                                We discuss your parent's daily routine, medical needs, and
                                location.
                            </p>
                        </div>
                    </li>
                    <li>
                        <span className="devine-step-num">2</span>
                        <div>
                            <h4>In-Home Assessment</h4>
                            <p>
                                We meet you and your parent at home to design a customized
                                care plan and match the right caregiver personality.
                            </p>
                        </div>
                    </li>
                    <li>
                        <span className="devine-step-num">3</span>
                        <div>
                            <h4>Care Begins — Fast</h4>
                            <p>
                                We accept urgent referrals and short-notice shifts around the
                                clock. Your caregiver's visits are logged and verified in
                                real time, so you get dependable updates, not guesswork.
                            </p>
                        </div>
                    </li>
                </ol>
            </section>

            {/* Final CTA */}
            <section className="devine-final-cta">
                <h2>Give Your Parent the Support They Need &amp; Get Your Peace of Mind Back</h2>
                <a href="#top" className="devine-cta">
                    SCHEDULE YOUR FREE CARE CONSULTATION
                </a>
                <p>
                    Or call us directly right now at{" "}
                    <a href="tel:4696057230">(469) 605-7230</a>
                </p>
            </section>
        </div>
    );
};

export default AADevine;